import { mapState, mapActions } from 'vuex';

export default {
  created() {
    this.recuperarImoveisMapa()
  },
  computed: {
    ...mapState('dashboardStore', {
      imoveis(state) { return state.imoveis }
    })
  },
  methods: {
    ...mapActions('dashboardStore', [
      'recuperarImoveisMapa'
    ])
  }

}